"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var accentColor = "Icons_accentColor__xq82d8h";
export var icon = _7a468({
  defaultClassName: "Icons_icon__xq82d85",
  variantClassNames: {
    size: {
      small: "Icons_icon_size_small__xq82d86",
      medium: "Icons_icon_size_medium__xq82d87",
      large: "Icons_icon_size_large__xq82d88"
    },
    color: {
      inherit: "Icons_icon_color_inherit__xq82d89",
      "default": "Icons_icon_color_default__xq82d8a",
      primary: "Icons_icon_color_primary__xq82d8b",
      active: "Icons_icon_color_active__xq82d8c",
      disabled: "Icons_icon_color_disabled__xq82d8d",
      critical: "Icons_icon_color_critical__xq82d8e",
      caution: "Icons_icon_color_caution__xq82d8f",
      success: "Icons_icon_color_success__xq82d8g"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var iconVars = {
  size: "var(--size__xq82d80)",
  color: "var(--color__xq82d81)",
  accentColor: "var(--accentColor__xq82d82)",
  transition: "var(--transition__xq82d83)"
};